import MixAndMatch from './MixAndMatch.vue';
import MixAndMatchList from './MixAndMatchList.vue';
export default {
  MixAndMatch,
  MixAndMatchList,
};
